import React from 'react'
import { Icon } from '@frontend/pole-ui/lib/components/Icon'
import { ClockIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ClockIcon'
import { isNonNullable } from '@/typeguards/common'
import { formatLocalizedString } from '@/utils/formatUtils'
import { messages } from './messages'
import type { TDaysUntilHarvestDeliveryProps } from './types'
import './styles.scss'

export const DaysUntilHarvestDelivery: React.FC<TDaysUntilHarvestDeliveryProps> = ({ days }) => {
  const text = isNonNullable(days) ? formatLocalizedString(messages.valueUnit, { days }) : '-'

  return (
    <span className="daysUntilHarvestDelivery">
      <Icon className="daysUntilHarvestDelivery__icon" component={<ClockIcon />} />
      <span className="h5">{text}</span>
    </span>
  )
}
